import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthResponse } from "reduxStore/dataTypes";

interface AuthState {
  user: AuthResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  user: null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authRequest(state) {
      state.loading = true;
      state.error = null;
    },
    authSuccess(state, action: PayloadAction<AuthResponse>) {
      state.loading = false;
      state.user = action.payload;
    },
    authFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { authRequest, authSuccess, authFailure } = authSlice.actions;
export default authSlice.reducer;
